import { supabase } from '../supabaseClient';

export const clientLogsService = {
    async getByClientId(clientId) {
        const { data, error } = await supabase
            .from('client_logs')
            .select('*')
            .eq('client_id', clientId)
            .order('created_at', { ascending: false });
        if (error) throw error;
        return data || [];
    },

    async create(log) {
        const { data, error } = await supabase
            .from('client_logs')
            .insert([log])
            .select()
            .single();
        if (error) throw error;
        return data;
    }
};
